/** Modes d'affichage des plannings ventes. */
export const PLANNING_VIEW_CLIENTS = 'clients';
export const PLANNING_VIEW_DISPOS = 'dispos';

export const isPlanningOptionRow = (row) => (
  String(row?.statut_phase ?? '').trim().toLowerCase() === 'option'
);

export const isPlanningIndispoRow = (row) => (
  String(row?.statut_phase ?? '').trim().toLowerCase() === 'indispo'
);

/** Emplacement libre (placeholder) ou ligne sans client (hors Option / Indispo). */
export const isPlanningEmptyRow = (row) => {
  if (row?.is_placeholder) return true;
  if (isPlanningOptionRow(row)) return false;
  if (isPlanningIndispoRow(row)) return false;
  return String(row?.client_label ?? '').trim() === '';
};

/** Indispo saisie sans nom de client : réservation du créneau, pas une dispo. */
export const isPlanningIndispoWithoutClient = (row) => (
  isPlanningIndispoRow(row) && String(row?.client_label ?? '').trim() === ''
);

/** Libellé client. Une Indispo sans nom s'affiche « Indispo ». */
export const getPlanningClientDisplay = (row, emptyLabel = '—') => {
  if (isPlanningIndispoWithoutClient(row)) return 'Indispo';
  const label = String(row?.client_label ?? '').trim();
  return label || emptyLabel;
};

/**
 * - clients (défaut) : hors vides et hors Options ; une Indispo sans client reste visible
 * - dispos : uniquement emplacements vides + Options
 */
export const filterPlanningRowsByViewMode = (rows, viewMode = PLANNING_VIEW_CLIENTS) => {
  const list = Array.isArray(rows) ? rows : [];
  if (viewMode === PLANNING_VIEW_DISPOS) {
    return list.filter((row) => isPlanningEmptyRow(row) || isPlanningOptionRow(row));
  }

  return list.filter((row) => {
    if (isPlanningEmptyRow(row) || isPlanningOptionRow(row)) return false;
    if (isPlanningIndispoWithoutClient(row)) return true;
    return String(row?.client_label ?? '').trim() !== '';
  });
};

/** Compteurs Clients / Dispos sur un jeu de lignes déjà filtré (période, etc.). */
export const countPlanningRowsByViewMode = (rows) => {
  const list = Array.isArray(rows) ? rows : [];
  let clients = 0;
  let dispos = 0;

  list.forEach((row) => {
    if (isPlanningEmptyRow(row) || isPlanningOptionRow(row)) {
      dispos += 1;
      return;
    }
    if (isPlanningIndispoWithoutClient(row) || String(row?.client_label ?? '').trim() !== '') {
      clients += 1;
    }
  });

  return { clients, dispos };
};

export const getPlanningViewEmptyMessage = (viewMode = PLANNING_VIEW_CLIENTS) => (
  viewMode === PLANNING_VIEW_DISPOS
    ? 'Aucun emplacement disponible (libre ou option) pour ces filtres.'
    : 'Aucune vente client pour ces filtres.'
);

const hasCommercialFilter = (commercialId) => {
  if (Array.isArray(commercialId)) return commercialId.length > 0;
  return commercialId != null && String(commercialId).trim() !== '';
};

/** En mode Dispos, force le filtre commercial sur « Tous » si besoin. */
export const ensureDisposCommercialFilterAll = (viewMode, commercialId, setFilters) => {
  if (viewMode !== PLANNING_VIEW_DISPOS || !hasCommercialFilter(commercialId)) return;
  setFilters((prev) => {
    if (!prev) return prev;
    if (Array.isArray(prev.commercial_id) || Array.isArray(commercialId)) {
      return { ...prev, commercial_id: [] };
    }
    return { ...prev, commercial_id: '' };
  });
};

/**
 * Bascule Clients / Dispos : en mode Dispos, le filtre commercial repasse sur « Tous ».
 */
export const handlePlanningViewModeChange = (nextMode, { setViewMode, setFilters, commercialId }) => {
  setViewMode(nextMode);
  ensureDisposCommercialFilterAll(nextMode, commercialId, setFilters);
};
